import { useEffect, useState } from "react";

const OrderCard = ({ order, socket }) => {
  const [orderStatus, setOrderStatus] = useState(order.status); // Використовуємо статус із бази

  useEffect(() => {
    if (!socket) return;

    const handleMessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.order_id === order.id) {
        setOrderStatus(data.status); // Оновлюємо статус при отриманні повідомлення
      }
    };

    socket.addEventListener("message", handleMessage);

    return () => {
      socket.removeEventListener("message", handleMessage);
    };
  }, [socket, order.id]);

  return (
    <div style={{ border: "1px solid #ddd", padding: "15px", marginBottom: "10px" }}>
      <h3>Користувач: {order.user_name}</h3>
      <p>Телефон: {order.user_phone}</p>
      <p>Доставка: {order.delivery_type} ({order.address_delivery})</p>
      <p>Час: {new Date(order.time_delivery).toLocaleString()}</p>
      <p>Оплата: {order.payment_method}</p>
      <h4>Страви:</h4>
      <ul>
        {order.dishes.map((dish) => (
          <li key={dish.dish_id}>
            {dish.name} - {dish.count} шт. ({dish.price} грн)
          </li>
        ))}
      </ul>
      <p>Сума: {order.total} грн</p>
      <p><strong>STATUS: {orderStatus}</strong></p>
    </div>
  );
};

export default OrderCard;
